import React from 'react';

import {TopBanner} from '../components/TopBanner';
import {Divider, Grid, Box} from '@mui/material';
import HsAppBar from '../components/HsAppBar';
import {connect} from 'react-redux';
import {selectCategory, selectTab} from '../store/actions/navigation';
import {Outlet} from "react-router-dom";
import Footer from '../components/Footer';
import {PortfolioPanel} from '../components/PortfolioPanel';


class Main extends React.Component {
	componentDidMount() {

	}

	render() {
		return (
			<Box >
				<Divider sx={{borderTop: '7px solid #60cc29'}}/>
				<HsAppBar/>
				<TopBanner/>
				<Grid container>
					<Grid item xs={12}>
						<PortfolioPanel/>
					</Grid>
					<Grid item xs={12}>
						<Outlet/>
					</Grid>
					<Grid item xs={12}>
						<Footer/>
					</Grid>
				</Grid>
			</Box>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		tabSelected: state.navigation.tabSelected,
	};
};

export default connect(mapStateToProps, {selectTab, selectCategory})(Main);
